<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft" @visibleChange="handleVisibleChange">
    <div :class="$style.dropdown">
      <a-badge :count="notifications.length">
        <i class="fe fe-bell" :class="$style.icon"></i>
      </a-badge>
    </div>
    <div slot="overlay">
      <div class="card cui__utils__shadow width-350">
        <div class="card-header bg-light">
          <div class="font-weight-bold font-size-16 test">Notifikasi</div>
        </div>
        <div class="card-body pb-2" style="max-height: 400px; overflow-y: auto;">
          <div v-if="notifications.length === 0" class="text-center py-3 text-muted">
            Tidak ada notifikasi baru
          </div>
          <div v-else>
            <div v-for="notif in notifications" :key="notif.id" class="d-flex flex-nowrap align-items-start mb-3 border-bottom pb-2">
              <div class="flex-grow-1">
                <p class="mb-1" style="font-size: 13px;">{{ notif.message }}</p>
                <small class="text-muted" style="font-size: 11px;">{{ formatDate(notif.createdAt) }}</small>
              </div>
              <a-button type="link" class="text-danger" size="small" @click.stop="deleteNotification(notif.id)">
                X
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-dropdown>
</template>

<script>
import apiClient from '@/services/axios'

export default {
  data() {
    return {
      notifications: [],
      pollInterval: null,
    }
  },
  mounted() {
    this.fetchNotifications()
    this.pollInterval = setInterval(this.fetchNotifications, 60000)
  },
  beforeDestroy() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval)
    }
  },
  methods: {
    handleVisibleChange(visible) {
      if (visible) {
        this.fetchNotifications()
      }
    },
    async fetchNotifications() {
      try {
        const res = await apiClient.get('/adminNotification')
        if (res.status === 200) {
          this.notifications = res.data
        }
      } catch (error) {
        console.error("Failed to fetch admin notifications", error)
      }
    },
    async deleteNotification(id) {
      try {
        const res = await apiClient.delete(`/adminNotification/${id}`)
        if (res.status === 200) {
          this.notifications = this.notifications.filter(n => n.id !== id)
        }
      } catch (error) {
        console.error("Failed to delete admin notification", error)
      }
    },
    formatDate(dateStr) {
      const d = new Date(dateStr)
      if (isNaN(d.getTime())) return ''
      return d.toLocaleDateString('id-ID', {
        day: '2-digit', month: 'short', year: 'numeric',
        hour: '2-digit', minute: '2-digit',
      })
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";

.dropdown {
  cursor: pointer;
  display: inline-block;
  padding: 0 10px;
}
.icon {
  font-size: 20px;
  color: #555;
}
</style>
